import React from 'react';
import { InformationalCallOut } from '@grnhse/seedling/lib/birch/components/call_out';
import { Grid } from '@grnhse/seedling/lib/birch/layouts/grid';
import { withLocalePrefix } from '../shared/utils/translation';
import AuthorizeAction from './authorize_action';
import ConsentTitle from './consent_title';
import RedirectDestination from './redirect_destination';
import { LogoContainer } from './styled_components';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';

const t = withLocalePrefix('authorization.authorization_form');

type Props = {
  name: string;
  accountSettingsUrl: string;
  companyLogoUrl?: string | null;
  denyUrl: string;
  clientIdHost?: string;
  redirectUriHost?: string;
  loopbackOnly?: boolean;
  emailValidation?: {
    email: string;
    error: string;
  };
};

export default function PublicClientAuthorizeForm({
  name,
  accountSettingsUrl,
  companyLogoUrl,
  denyUrl,
  clientIdHost,
  redirectUriHost,
  loopbackOnly,
  emailValidation,
}: Props) {
  const onCancel = () => {
    window.location.href = denyUrl;
  };

  return (
    <Stack>
      <ConsentTitle name={name} clientIdHost={clientIdHost} />
      {redirectUriHost && (
        <RedirectDestination
          host={redirectUriHost}
          loopbackOnly={loopbackOnly}
        />
      )}
      <InformationalCallOut bodyText={t('beta_callout')} />
      <Grid container spacing={3}>
        <Grid item xs={7}>
          <AuthorizeAction
            accountSettingsUrl={accountSettingsUrl}
            error={emailValidation?.error}
            email={emailValidation?.email}
            onCancel={onCancel}
          />
        </Grid>
        {companyLogoUrl && (
          <Grid item xs={5}>
            <LogoContainer>
              <img src={companyLogoUrl} alt={name} />
            </LogoContainer>
          </Grid>
        )}
      </Grid>
    </Stack>
  );
}
